import { useStore } from "@/lib/store";

export default function RulesPage() {
  const { t, language } = useStore();

  const isRu = language === "RU";

  return (
    <div className="max-w-3xl mx-auto px-4 py-12 animate-fade-in">
      <h1 className="font-display text-2xl tracking-wider mb-8">{t("rules")}</h1>

      <div className="space-y-8 text-sm leading-relaxed">

        <div className="space-y-3">
          <h2 className="font-display text-lg tracking-wider text-white">
            {isRu ? "КАК ОФОРМИТЬ ЗАКАЗ?" : "HOW TO ORDER?"}
          </h2>
          <div className="text-zinc-400 space-y-2">
            <p>{isRu
              ? "Выберите понравившуюся вещь, добавьте в корзину, укажите размер. Заполните имя и контакт для связи — с вами свяжется менеджер для подтверждения и оплаты заказа."
              : "Choose an item, add to cart, select your size. Fill in your name and contact — a manager will reach out to confirm and process payment."}</p>
            <p>{isRu
              ? "Также можно написать напрямую админу: "
              : "You can also message the admin directly: "}
              <a href="https://t.me/XruuXruu" target="_blank" rel="noopener noreferrer" className="text-white underline underline-offset-4 hover:text-zinc-300">@XruuXruu</a>
            </p>
          </div>
        </div>

        <div className="space-y-3">
          <h2 className="font-display text-lg tracking-wider text-white">
            {isRu ? "ДОСТАВКА" : "SHIPPING"}
          </h2>
          <div className="space-y-2">
            <div className="p-4 border border-zinc-800">
              <p className="text-white font-display tracking-wider text-xs mb-2">{isRu ? "БЕЛАРУСЬ" : "BELARUS"}</p>
              <p className="text-zinc-400">{isRu ? "Европочта — 100% предоплата" : "Europochta — 100% prepayment"}</p>
            </div>
            <div className="p-4 border border-zinc-800">
              <p className="text-white font-display tracking-wider text-xs mb-2">{isRu ? "РОССИЯ" : "RUSSIA"}</p>
              <p className="text-zinc-400">{isRu ? "CDEK — 100% предоплата" : "CDEK — 100% prepayment"}</p>
            </div>
            <p className="text-zinc-500 text-xs font-mono">
              {isRu ? "Отправка каждые 2–3 дня" : "Shipping every 2–3 days"}
            </p>
          </div>
        </div>

        <div className="space-y-3">
          <h2 className="font-display text-lg tracking-wider text-white">
            {isRu ? "ВАЖНО" : "IMPORTANT"}
          </h2>
          <div className="text-zinc-400 space-y-2">
            <p className="text-red-400/80 font-display tracking-wider text-xs">
              {isRu ? "ВОЗВРАТА НЕТ" : "NO RETURNS"}
            </p>
            <p>{isRu
              ? "Уточняйте всю информацию перед покупкой. Вы всегда можете попросить дополнительные фото, видео и замеры."
              : "Please clarify all details before purchasing. You can always request additional photos, videos and measurements."}</p>
            <p>{isRu
              ? "Мы консультируем по подбору размера и стиля. Всегда можно обсудить цену — приятным покупателям делаем скидки."
              : "We offer size and style consultations. We're always open to discussing prices — loyal customers get discounts."}</p>
          </div>
        </div>

        <div className="space-y-3">
          <h2 className="font-display text-lg tracking-wider text-white">
            {isRu ? "ОТЗЫВЫ И ГАРАНТИЯ" : "REVIEWS & GUARANTEE"}
          </h2>
          <a href="https://t.me/+Xbc3YR-glUg4YzBi" target="_blank" rel="noopener noreferrer"
            className="flex items-center justify-between p-4 border border-zinc-800 hover:bg-zinc-900 transition-colors group">
            <div>
              <p className="text-white font-display tracking-wider text-xs">
                {isRu ? "КАНАЛ С ОТЗЫВАМИ" : "REVIEWS CHANNEL"}
              </p>
              <p className="text-zinc-500 text-xs mt-1">
                {isRu ? "Авторам отзывов можно написать и убедиться в честности" : "You can message review authors to verify authenticity"}
              </p>
            </div>
            <span className="text-zinc-600 group-hover:text-white transition-colors">→</span>
          </a>
        </div>

        <div className="space-y-3">
          <h2 className="font-display text-lg tracking-wider text-white">
            {isRu ? "НАЛИЧИЕ" : "AVAILABILITY"}
          </h2>
          <a href="https://t.me/hisstorycall" target="_blank" rel="noopener noreferrer"
            className="flex items-center justify-between p-4 border border-zinc-800 hover:bg-zinc-900 transition-colors group">
            <div>
              <p className="text-white font-display tracking-wider text-xs">
                {isRu ? "АКТУАЛЬНОЕ НАЛИЧИЕ" : "CURRENT STOCK"}
              </p>
              <p className="text-zinc-500 text-xs mt-1">@hisstorycall</p>
            </div>
            <span className="text-zinc-600 group-hover:text-white transition-colors">→</span>
          </a>
        </div>

      </div>
    </div>
  );
}